import { Component, Input } from '@angular/core';

export type SelectionListAlignment = 'vertical' | 'horizontal';

@Component({
  selector: 'fi-selection-list',
  templateUrl: './selection-list.component.html',
  styleUrls: ['./selection-list.component.scss'],
  standalone: false,
})
export class SelectionListComponent {
  @Input() heading?: string;
  @Input() required = false;
  @Input() alignment: SelectionListAlignment = 'vertical';
  @Input() error?: string;
}
